<!-- @ts-nocheck -->
<template>
  <a-table
    :class="`${bem.e('main-content')}`"
    v-bind="attrs"
    :show-header="showHeader"
    :row-key="rowKey"
    :columns="newColumns"
    :data-source="newDataSource"
    :expanded-row-keys="newExpandedRowKeys"
    :custom-row="props.showDrag ? dragCustomRow : (customRowProps as any)"
    :pagination="false"
    :scroll="scroll"
    @expand="handleExpand"
    @resize-column="handleResizeColumn"
    @change="props.change!"
    @expanded-rows-change="props.expandedRowsChange!"
  >
    <!-- 1.表头插槽 -->
    <template #headerCell="slots">
      <div :class="`${bem.e('header-cell-content')}`">
        <template v-if="slots.column.key === 'operate' && showSetting">
          <div :class="`${bem.e('operate')}`">
            <ll-html
              v-if="!slots.column.hiddenTitle"
              :value="slots.column.title"
            />
            <a-popover
              trigger="click"
              placement="bottomRight"
              :overlay-inner-style="{
                padding: '0',
              }"
            >
              <template #content>
                <div :class="`${bem.e('setting-popover')}`">
                  <!-- 头部 -->
                  <div :class="`${bem.e('setting-popover-header')}`">
                    <a-checkbox
                      :indeterminate="isIndeterminate"
                      :checked="isAllCheck"
                      @change="handleAllColumnChange"
                    >
                      列展示
                    </a-checkbox>
                    <span
                      :class="`${bem.e('setting-reset-btn')}`"
                      @click="handleClickResetBtn"
                    >
                      重置
                    </span>
                  </div>
                  <!-- 内容 -->
                  <div :class="`${bem.e('setting-popover-content')}`">
                    <div>
                      <draggable
                        :list="settingColumns"
                        item-key="key"
                        :group="{ name: 'g1' }"
                        @change="dragChange"
                      >
                        <template #item="{ element }">
                          <div :class="`${bem.e('setting-popover-menu')}`">
                            <!-- 拖拽 -->
                            <div
                              :class="`flex items-center ${bem.e(
                                'setting-popover-menu-left',
                              )}`"
                            >
                              <a-button
                                type="text"
                                :class="`${bem.e('setting-popover-menu-icon')}`"
                                :style="{
                                  marginright: '5px',
                                }"
                              >
                                <ll-icon
                                  icon-name="icon-move"
                                  class-name="icon"
                                />
                              </a-button>
                              <a-checkbox
                                :checked="element.isCheck"
                                @change="
                                  (e: any) => {
                                    handleColumnItemChange(
                                      e.target?.checked!,
                                      element,
                                    )
                                  }
                                "
                              >
                                {{ element.title }}
                              </a-checkbox>
                            </div>
                            <div
                              :class="`flex items-center ${bem.e(
                                'setting-popover-menu-right',
                              )}`"
                            >
                              <!-- 左移 -->
                              <a-button
                                type="text"
                                :class="`${bem.e('setting-popover-menu-icon')}`"
                                @click="handleColumnMove(element, 'left')"
                              >
                                <ll-icon
                                  icon-name="icon-zuoyi"
                                  :class-name="`icon ${
                                    element.fixed === 'left'
                                      ? bem.e('setting-popover-menu-fixed-icon')
                                      : ''
                                  }`"
                                />
                              </a-button>
                              <a-divider type="vertical" />
                              <!-- 右移 -->
                              <a-button
                                type="text"
                                :class="`${bem.e('setting-popover-menu-icon')}`"
                                @click="handleColumnMove(element, 'right')"
                              >
                                <ll-icon
                                  icon-name="icon-youyi"
                                  :class-name="`icon ${
                                    element.fixed === 'right'
                                      ? bem.e('setting-popover-menu-fixed-icon')
                                      : ''
                                  }`"
                                />
                              </a-button>
                            </div>
                          </div>
                        </template>
                      </draggable>
                    </div>
                  </div>
                </div>
              </template>
              <a-button type="text" :class="`${bem.e('setting-icon')}`">
                <ll-icon icon-name="icon-set-line" />
              </a-button>
            </a-popover>
          </div>
        </template>
        <template v-else-if="has(slots.column, 'RC_TABLE_INTERNAL_COL_DEFINE')">
          <slot name="expandedTitle"></slot>
        </template>

        <slot name="tableHeaderCell" v-bind="slots">
          <ll-html :value="slots.column.title" />
        </slot>
      </div>
    </template>
    <!-- 2.表格内容插槽 -->
    <template #bodyCell="slots">
      <!-- 添加序列列 -->
      <template v-if="slots.column.key === indexColumnTitle && showIndexColumn">
        {{ slots.index + 1 }}
      </template>
      <!-- 添加操作列 -->
      <template v-else-if="slots.column.key === 'operate'">
        <slot name="tableOperate" v-bind="slots"></slot>
      </template>
      <!-- 额外Body单元格的插槽内容 -->
      <slot name="tableBodyCell" v-bind="slots"></slot>
    </template>
    <!-- 3.空状态自定义插槽 -->
    <template #emptyText>
      <slot name="emptyText">
        <ll-empty v-bind="emptyProps"> </ll-empty>
      </slot>
    </template>
    <!-- 4.表格自定义展开内容插槽 -->
    <template v-if="$slots.expandedRow" #expandedRowRender="slots">
      <slot name="expandedRow" v-bind="slots"> </slot>
    </template>
    <!-- 5.表格自定义列筛选 -->
    <template v-if="$slots.customFilterDropdown" #customFilterDropdown="slots">
      <slot name="customFilterDropdown" v-bind="slots"> </slot>
    </template>
    <!-- 6.表格自定义筛选图标 -->
    <template v-if="$slots.customFilterIcon" #customFilterIcon="slots">
      <slot name="customFilterIcon" v-bind="slots"> </slot>
    </template>
    <!-- 6.表格总结栏 -->
    <template v-if="$slots.summary" #summary="slots">
      <slot name="summary" v-bind="slots"> </slot>
    </template>
    <!-- 7.自定义展开图标 -->
    <template v-if="$slots.expandIcon" #expandIcon="slots">
      <slot name="expandIcon" v-bind="slots"> </slot>
    </template>
  </a-table>
</template>
<script lang="ts" setup>
// @ts-nocheck
import { computed, ref, useAttrs, watch } from 'vue'

import { useLocale } from '@ll-plus/hooks'
import { createNamespace } from '@ll-plus/utils'

import draggable from 'vuedraggable'

import { has } from 'lodash-es'
import { proMainTableEmits, proMainTableProps } from '../config'

// 1.defineOptions
defineOptions({
  name: 'LlMainTable',
})

// 2.props/emits
const props = defineProps(proMainTableProps)
const emits = defineEmits(proMainTableEmits)
// 3.hooks
const attrs = useAttrs()
const { t } = useLocale()
// 3.ref/let/const
const newColumns: any = ref([]) // 显示在表格的columns
const settingColumns: any = ref([])
const newDataSource: any = ref([])
const newExpandedRowKeys: any = ref([]) //展开的id数组
let preIndex = -1 // 源目标数据序号
let nextIndex = -1 // 目标数据序号
const bem = createNamespace('table')

// 往表格列中添加序号和操作
const handleAddSerialNumberAndOperateToColumns = () => {
  const {
    showIndexColumn,
    indexColumnTitle,
    indexColumnWidth,
    showOperate,
    operateTitle,
    operatePosition,
  } = props
  const firstColumn = newColumns.value[0]
  if (showIndexColumn) {
    newColumns.value.unshift({
      title: indexColumnTitle,
      dataIndex: indexColumnTitle,
      key: indexColumnTitle,
      hiddenTitle: firstColumn?.hiddenTitle,
      maxWidth: indexColumnWidth,
      minWidth: indexColumnWidth,
      width: indexColumnWidth,
      fixed: 'left',
      class: 'table-serial-number-cell',
    })
  }
  //  ...(props.size ? { 'font-size': addUnit(props.size) } : {}),
  if (showOperate) {
    let maxWidth = 70
    let minWidth = 120
    let width = 120
    if (props.operateWidth) {
      const operateWidth = +props.operateWidth
      maxWidth = operateWidth
      minWidth = operateWidth
      width = operateWidth
    }
    const opt = {
      title: operateTitle,
      dataIndex: operateTitle,
      key: 'operate',
      hiddenTitle: firstColumn?.hiddenTitle,
      maxWidth,
      minWidth,
      width,
      fixed: operatePosition,
      class: 'table-serial-operate-cell',
    }
    if (operatePosition === 'normal') {
      delete opt.fixed
    }
    if (operatePosition === 'left') {
      newColumns.value.unshift(opt)
    } else {
      newColumns.value.push(opt)
    }
  }
}
// 处理表格列的左、右固定排序(letf放最左边，没有定位放中间，右边放right定位）
const handleColumnsSortByFixed = (list: any, isDrag?: boolean) => {
  const newList = list
  const leftFixedColumns: any = [],
    normalFixedColumns: any = [],
    rightFixedColumns: any = []
  newList.forEach((item: any) => {
    const fixed = item.fixed
    if (fixed === 'left') {
      leftFixedColumns.push(item)
    } else if (fixed === 'right') {
      rightFixedColumns.push(item)
    } else {
      normalFixedColumns.push(item)
    }
  })
  leftFixedColumns.sort(
    (a: any, b: any) => a.columnSortIndex - b.columnSortIndex,
  )
  normalFixedColumns.sort(
    (a: any, b: any) => a.columnSortIndex - b.columnSortIndex,
  )
  rightFixedColumns.sort(
    (a: any, b: any) => a.columnSortIndex - b.columnSortIndex,
  )
  newColumns.value = [
    ...leftFixedColumns,
    ...normalFixedColumns,
    ...rightFixedColumns,
  ]
  if (isDrag) {
    handleAddSerialNumberAndOperateToColumns()
  }
}

// 4.watch
watch(
  () => props.dataSource,
  (newValue: any) => {
    newDataSource.value = [...newValue]
  },
  {
    deep: true,
    immediate: true,
  },
)
// 从本地存储中获取columns/没有则用用户传的
watch(
  () => [
    props.columns,
    props.settingKey,
    props.showOperate,
    props.showIndexColumn,
    props.indexColumnTitle,
    props.indexColumnWidth,
    props.operateWidth,
    props.operatePosition,
    props.operateTitle,
  ],
  (arr: any) => {
    const [newValue, key] = arr
    let newcolumns = []
    // 有key
    if (key && localStorage.getItem(key)) {
      const localStorageColumns = localStorage.getItem(key)
      if (localStorageColumns) {
        newcolumns = JSON.parse(localStorageColumns)
      }
    } else {
      // 没key
      newcolumns = newValue.map((item: any, index: number) => ({
        ...item,
        isCheck: true,
        columnSortIndex:
          item.columnSortIndex === 0 || item.columnSortIndex
            ? item.columnSortIndex
            : index,
      }))
    }
    // 1.过滤掉没有选中的
    newColumns.value = [...newcolumns].filter((item: any) => item.isCheck)
    // 2.如果有设置序列和操作，则添加
    handleAddSerialNumberAndOperateToColumns()
    // 3.根据定位来排序
    handleColumnsSortByFixed(newColumns.value)
    settingColumns.value = [...newcolumns]
  },
  {
    deep: true,
    immediate: true,
  },
)
watch(
  () => props.expandedRowKeys,
  (newValue: any) => {
    if (Array.isArray(newValue)) {
      newExpandedRowKeys.value = [...newValue]
    }
  },
  {
    deep: true,
    immediate: true,
  },
)
// 5.methods
//重新定义树状展开关闭功能
const handleExpand = (expanded: boolean, record: any) => {
  if (expanded) {
    newExpandedRowKeys.value.push(record.id)
  } else {
    const index = newExpandedRowKeys.value.findIndex(
      (e: any) => e === record.id,
    )
    newExpandedRowKeys.value.splice(index, 1)
  }
  props.expand && props.expand(expanded, record)
}
// 列拖拽
const handleResizeColumn = (w: any, col: any) => {
  col.width = w
  props.resizeColumn && props.resizeColumn(w, col)
}
// 拖动排序
const dragCustomRow = (_: any, index: number) => {
  const normalConfig = {
    props: {
      // draggable: 'true'
    },
    draggable: true,
    style: {
      cursor: 'pointer',
    },
    // 鼠标移入
    onMouseenter: (event: Event) => {
      const target = event.target as HTMLElement
      target.draggable = true // 让你要拖动的行可以拖动，默认不可以
    },
    // 开始拖拽
    onDragstart: (event: Event) => {
      event.stopPropagation()
      preIndex = index
    },
    // 拖动元素经过的元素
    onDragover: (event: Event) => {
      event.preventDefault()
    },
    // 鼠标松开
    onDrop: (event: Event) => {
      let sortSource: any[] = []
      event.stopPropagation()
      // 得到目标数据序号
      nextIndex = index
      const dataSource = newDataSource.value
      // 排序后两个sort互换
      const preItem = { ...dataSource[preIndex] }
      const nextItem = { ...dataSource[nextIndex] }
      const preSort = preItem.sort
      const nextSort = nextItem.sort
      preItem.sort = nextSort
      nextItem.sort = preSort

      dataSource[preIndex] = nextItem
      dataSource[nextIndex] = preItem
      sortSource = [...dataSource]
      emits('handleChangeDataSource', sortSource)
      props.dragChange && props.dragChange(sortSource)
    },
  }
  const extraConfig = props.customRowProps
    ? { ...props.customRowProps(_, index) }
    : {}
  return { ...normalConfig, ...extraConfig }
}
// 是否全选
const isAllCheck = computed(() => {
  return settingColumns.value.every((item: any) => item.isCheck)
})
// 是否全选
const isIndeterminate = computed(() => {
  const getIsChecks = settingColumns.value.filter((item: any) => item.isCheck)
  return getIsChecks.length === 0
    ? false
    : settingColumns.value.length > getIsChecks.length
})
// 单个checkbox的change
const handleChangeColumns = () => {
  const isCheckSettingColumns = settingColumns.value.filter(
    (item: any, index: number) => {
      item.columnSortIndex = index
      return item.isCheck
    },
  )
  handleColumnsSortByFixed(isCheckSettingColumns, true)
}

const handleColumnItemChange = (value: boolean, item: any) => {
  const findSettingIndex = settingColumns.value.findIndex(
    (citem: any) => item.key === citem.key,
  )

  if (findSettingIndex > -1) {
    settingColumns.value[findSettingIndex].isCheck = value
    handleChangeColumns()
    handleClickSubmitBtn()
  }
}
// 全选change
const handleAllColumnChange = (e: any) => {
  const checked = e.target.checked
  settingColumns.value.forEach((item: any) => (item.isCheck = checked))
  if (checked) {
    newColumns.value = [...props.columns]
  } else {
    newColumns.value = []
  }
  handleAddSerialNumberAndOperateToColumns()
  handleClickSubmitBtn()
}
// 拖拽change
const dragChange = () => {
  handleChangeColumns()
  handleClickSubmitBtn()
}
// 点击重置按钮
const handleClickResetBtn = () => {
  const newcolumns = props.columns.map((item: any, index: number) => ({
    ...item,
    isCheck: true,
    columnSortIndex: index,
  }))
  newColumns.value = [...newcolumns]
  handleAddSerialNumberAndOperateToColumns()
  settingColumns.value = [...newcolumns]
  handleClickSubmitBtn()
}
// 点击保存按钮
const handleClickSubmitBtn = () => {
  if (props.settingKey) {
    localStorage.setItem(props.settingKey, JSON.stringify(settingColumns.value))
  }
}
// 处理column左固定和右固定
const handleColumnMove = (element: any, way: string) => {
  const fixed = element.fixed
  if (fixed === way) {
    element.fixed = false
  } else {
    element.fixed = way
  }
  handleColumnsSortByFixed(newColumns.value)
  handleClickSubmitBtn()
}
</script>
